import { render, staticRenderFns } from "./areaRemove.vue?vue&type=template&id=92e9be3a&scoped=true"
import script from "./areaRemove.vue?vue&type=script&lang=js"
export * from "./areaRemove.vue?vue&type=script&lang=js"
import style0 from "./areaRemove.vue?vue&type=style&index=0&id=92e9be3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e9be3a",
  null
  
)

export default component.exports